import { combineReducers } from 'redux';
import bachelor from './bachelor';

const reducers = {
  bachelor,
};

export default combineReducers(reducers);
